import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';

export default function ResetPasswordModal({ userId, onClose, onReset }) {
  const { theme } = useTheme();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleReset = async () => {
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    try {
      await onReset(userId, password);
      onClose();
    } catch (err) {
      setError(err.data?.error || 'Failed to reset password');
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} style={{
        width: 400, padding: 28,
        background: theme.bg, border: `2px solid ${theme.text}`,
      }}>
        <h3 style={{ fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 450, margin: '0 0 4px', fontSize: 20, color: theme.text }}>reset password</h3>
        <p style={{ fontSize: 12, color: theme.textFaint, margin: '0 0 20px' }}>
          set a new password for this user. they can also log in with Google.
        </p>

        {error && (
          <div style={{ padding: '8px 12px', marginBottom: 16, border: `1px solid ${theme.redBorder}`, color: theme.red, fontSize: 12 }}>{error}</div>
        )}

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>new password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="min. 8 characters" autoFocus
            onKeyDown={e => { if (e.key === 'Enter') handleReset(); }}
            style={{ width: '100%', height: 40, padding: '0 12px', background: 'transparent', border: `1px solid ${theme.borderMedium}`, borderRadius: 0, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ display: 'flex' }}>
          <button onClick={onClose} style={{ flex: 1, height: 42, background: 'transparent', border: `1px solid ${theme.borderMedium}`, color: theme.text, fontSize: 13, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit' }}>cancel</button>
          <button onClick={handleReset} style={{ flex: 1, height: 42, background: theme.red, border: 'none', color: '#FFFFFF', fontSize: 13, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit' }}>reset password</button>
        </div>
      </div>
    </div>
  );
}
